<script setup lang="ts">
import Button from "primevue/button";

function login(): void {
  window.location.href = "/auth/login";
}
</script>

<template>
  <section class="login-card">
    <h2>Sign in</h2>
    <p>
      Authenticate to view reviews and quality events. Your access is scoped to
      your role; managers see everything, contributors see what concerns them.
    </p>
    <Button
      label="Sign in with SSO"
      icon="pi pi-sign-in"
      data-testid="login-button"
      @click="login"
    />
  </section>
</template>

<style scoped>
.login-card {
  max-width: 460px;
  margin: 64px auto;
  padding: 32px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.login-card h2 {
  margin: 0 0 8px;
  font-size: 18px;
}
.login-card p {
  color: var(--p-surface-600);
  font-size: 14px;
  margin: 0 0 20px;
}
</style>
